// src/api/http.js
import axios from 'axios';

const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || 'http://localhost:8080',
  headers: {
    'Content-Type': 'application/json', // <- ensure JSON body
  },
});

// attach token from localStorage if present
http.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default http;
